// §15 / D-043 — the house sound set: short, warm, two tones at most. Nothing here is a file.
import type { SoundId, SoundRecipe } from '@hangar/shared';

export const houseSounds: Record<SoundId, SoundRecipe> = {
  notify: {
    tones: [
      { wave: 'sine', freq: 784, at: 0, duration: 0.07, gain: 0.16, attack: 0.004, release: 0.04 },
      { wave: 'sine', freq: 1046, at: 0.06, duration: 0.1, gain: 0.12, attack: 0.004, release: 0.06 },
    ],
  },
  error: {
    tones: [
      { wave: 'triangle', freq: 330, at: 0, duration: 0.09, gain: 0.18, release: 0.05 },
      { wave: 'triangle', freq: 247, at: 0.08, duration: 0.13, gain: 0.16, release: 0.08 },
    ],
  },
  snap: {
    tones: [{ wave: 'sine', freq: 620, endFreq: 880, at: 0, duration: 0.06, gain: 0.1, release: 0.03 }],
  },
  trash: {
    tones: [
      { wave: 'sawtooth', freq: 420, endFreq: 180, at: 0, duration: 0.14, gain: 0.09, release: 0.09 },
    ],
  },
  screenshot: {
    tones: [{ wave: 'square', freq: 1400, at: 0, duration: 0.03, gain: 0.07, release: 0.02 }],
  },
  deviceConnect: {
    tones: [
      { wave: 'sine', freq: 587, at: 0, duration: 0.07, gain: 0.12, release: 0.04 },
      { wave: 'sine', freq: 880, at: 0.07, duration: 0.09, gain: 0.12, release: 0.05 },
    ],
  },
  startup: {
    tones: [
      { wave: 'sine', freq: 392, at: 0, duration: 0.16, gain: 0.1, attack: 0.03, release: 0.1 },
      { wave: 'sine', freq: 587, at: 0.1, duration: 0.2, gain: 0.09, attack: 0.03, release: 0.14 },
      { wave: 'sine', freq: 784, at: 0.2, duration: 0.26, gain: 0.08, attack: 0.03, release: 0.2 },
    ],
  },
};
